import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { setMessage } from "./alertMessageSlice";
import OperationService from "../services/operation.service";

export const createUploadJobSlice = createAsyncThunk(
  "operation/createUploadJob",
  async ({ body }, thunkAPI) => {
    try {
      const brandUser = JSON.parse(sessionStorage.getItem("brandUser"));

      const response = await OperationService.createNewJobUpload(
        brandUser?.tenant_id,
        body
      );
      thunkAPI.dispatch(
        setMessage({
          message: 'Added to Database successfully!!',
          type: 'Success',
        })
      );

      return response;
    } catch (error) {
      const message =
        error?.response?.data?.message ||
        error?.response?.data?.detail ||
        error?.message ||
        error.toString();

      thunkAPI.dispatch(
        setMessage({
          message,
          type: "rejected",
        })
      );

      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const updateOperationDataPertSlice = createAsyncThunk(
  "operation/updateOperationDataPert",
  async (body, thunkAPI) => {
    try {
      const brandUser = JSON.parse(sessionStorage.getItem("brandUser"));
      console.log(body, "brandUser");


      const response = await OperationService.updateOperationDataPert(
        brandUser?.tenant_id,
        body
      );
      
      thunkAPI.dispatch(
        setMessage({
          message: 'Updated to Database successfully!!',
          type: 'Success',
        })
      );


      return response;
    } catch (error) {
      const message =
        error?.response?.data?.message ||
        error?.response?.data?.detail ||
        error?.message ||
        error.toString();

      thunkAPI.dispatch(
        setMessage({
          message,
          type: "rejected",
        })
      );

      return thunkAPI.rejectWithValue(message);
    }
  }
);


export const getOperationDateDataSlice = createAsyncThunk(
  "operation/getOperationDateData",
  async (body, thunkAPI) => {
    try {
      const brandUser = JSON.parse(sessionStorage.getItem("brandUser"));
      console.log(body, "brandUser");


      const response = await OperationService.getOperationDateData(
        brandUser?.tenant_id,
        body
      );

      return response;
    } catch (error) {
      const message =
        error?.response?.data?.message ||
        error?.response?.data?.detail ||
        error?.message ||
        error.toString();

      thunkAPI.dispatch(
        setMessage({
          message,
          type: "rejected",
        })
      );

      return thunkAPI.rejectWithValue(message);
    }
  }
);


export const getOperationDataPertSlice = createAsyncThunk(
  "operation/getOperationDataPert",
  async (body, thunkAPI) => {
    try {
      const brandUser = JSON.parse(sessionStorage.getItem("brandUser"));
      console.log(body, "brandUser");


      const response = await OperationService.getOperationDataPert(
        brandUser?.tenant_id,
        body
      );
      if (body?.name == 'SBD' || body?.name == 'Digi Yatra E-Gate Utilization') {
        thunkAPI.dispatch(getOperationDateDataSlice({ "post_id": body?.post_id || '' }))

      } else if (body?.name == 'Campaigns'){
        thunkAPI.dispatch(getOperationDateDataSlice({ "post_id": body?.post_id || '' , "target": body?.target || "Digiyatra"}))
      }else{

        thunkAPI.dispatch(getOperationDateDataSlice({ "post_id": body?.post_id || '' }))
      }

      return response;
    } catch (error) {
      const message =
        error?.response?.data?.message ||
        error?.response?.data?.detail ||
        error?.message ||
        error.toString();

      thunkAPI.dispatch(
        setMessage({
          message,
          type: "rejected",
        })
      );

      return thunkAPI.rejectWithValue(message);
    }
  }
);


export const deleteOperationDataSlice = createAsyncThunk(
  "operation/deleteOperationData",
  async (body, thunkAPI) => {
    try {
      const brandUser = JSON.parse(sessionStorage.getItem("brandUser"));
      console.log(body, "brandUser");


      const response = await OperationService.deleteOperationData(
        brandUser?.tenant_id,
        body
      );
      
      thunkAPI.dispatch(
        setMessage({
          message: 'Successfully Deleted!!',
          type: 'Success',
        })
      );

      thunkAPI.dispatch(getOperationDataSlice());

      return response;
    } catch (error) {
      const message =
        error?.response?.data?.message ||
        error?.response?.data?.detail ||
        error?.message ||
        error.toString();

      thunkAPI.dispatch(
        setMessage({
          message,
          type: "rejected",
        })
      );

      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const getOperationDataSlice = createAsyncThunk(
  "operation/getOperationData",
  async (_, thunkAPI) => {
    try {
      const brandUser = JSON.parse(sessionStorage.getItem("brandUser"));
      console.log(brandUser, "brandUser");

      const response = await OperationService.getOperationData(
        brandUser?.tenant_id
      );

      return response;
    } catch (error) {
      const message =
        error?.response?.data?.message ||
        error?.response?.data?.detail ||
        error?.message ||
        error.toString();

      thunkAPI.dispatch(
        setMessage({
          message,
          type: "rejected",
        })
      );

      return thunkAPI.rejectWithValue(message);
    }
  }
);

const initialState = {
  operations_data: [],
  operations_data_pert: [],
  operations_data_table: [],
  operations_date_data: [],
  loading: false,
  error: null,
  resetFlag: false,
};

const operationSlice = createSlice({
  name: "operation",
  initialState,
  reducers: {
    resetFlagFunc: (state, action) => {
      state.resetFlag = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      // Upload Job
      .addCase(createUploadJobSlice.pending, (state) => {
        state.loading = true;
      })
      .addCase(createUploadJobSlice.fulfilled, (state, action) => {
        state.loading = false;
        state.operations_data = action?.payload?.data || [];
      })
      .addCase(createUploadJobSlice.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.operations_data = [];
      })

      // Get Operation Data
      .addCase(getOperationDataSlice.pending, (state) => {
        state.loading = true;
      })
      .addCase(getOperationDataSlice.fulfilled, (state, action) => {
        state.loading = false;
        console.log(action?.payload, "action?.payload");

        state.operations_data_table = action?.payload || [];
      })
      .addCase(getOperationDataSlice.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.operations_data_table = [];
      })
      

      // Get Operation Data
      .addCase(deleteOperationDataSlice.pending, (state) => {
        state.loading = true;
      })
      .addCase(deleteOperationDataSlice.fulfilled, (state, action) => {
        state.loading = false;
        console.log(action?.payload, "action?.payload");
      })
      .addCase(deleteOperationDataSlice.rejected, (state, action) => {
        state.loading = false;
      })

      // Get Operation Data
      .addCase(getOperationDataPertSlice.pending, (state) => {
        state.loading = true;
      })
      .addCase(getOperationDataPertSlice.fulfilled, (state, action) => {
        state.loading = false;
        console.log(action?.payload, "action?.payload");

        state.operations_data_pert = action?.payload || [];
      })
      .addCase(getOperationDataPertSlice.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.operations_data_pert = [];
      })
      .addCase(getOperationDateDataSlice.pending, (state) => {
        state.loading = true;
      })
      .addCase(getOperationDateDataSlice.fulfilled, (state, action) => {
        state.loading = false;
        console.log(action?.payload, "action?.payload");

        state.operations_date_data = action?.payload || [];
      })
      .addCase(getOperationDateDataSlice.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.operations_date_data = [];
      })



  },
});

export const { resetFlagFunc } = operationSlice.actions;

export default operationSlice.reducer;